<template>
  <div
    class="
      garden-help-reset-password garden-help-auth-container garden-help-auth-bg-container
    "
  >
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <ResetPassword
            titleH2=""
            welcomeHeader="Reset your password"
            welcomeSubheader="Enter your new password to log in to your account now."
           logoSrc="garden-help/Logo.png"
            guard="GARDENHELP"
            clientLink="garden_help"
            :token="$route.query.token"
            :email="$route.query.email"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPassword from "@/components/auth/ResetPassword.vue";

export default {
  name: "GardenHelpResetPassword",
  components: { ResetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit reset password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../styles/garden-help-auth-styles.css";


body.swal2-height-auto {
    height: 100vh !important;
}
</style>




// WEBPACK FOOTER //
// src/projects/garden_help/auth/ResetPasswordView.vue